export const isNull = (param) => param === null || param === undefined

export const ItemCollaboratorListParser = ({ data = [], }) => data.map((e) => new ItemCollaborator(e));

export class ItemCollaborator {
  constructor({
    id = null,
    idBranch = null,
    name = null,
    date = null,
    startDate = null,
    endDate = null,
    peopleCount = null,
    createdAt = null,
    deleted = null,
    visitType = null,
    collaborator = null,
    linkedPoll = null,
    customVisitHosts = null,
    hosts = null,
    reason = null,
    anyEmail = null,
    isFromSocket = false,
    status = null
  } = {}) {
    this.id = isNull(id) ? null : id;
    this.idBranch = isNull(idBranch) ? null : idBranch;
    this.name = isNull(name) ? null : name;
    this.date = isNull(date) ? null : date;
    this.startDate = isNull(startDate) ? null : startDate;
    this.endDate = isNull(endDate) ? null : endDate;
    this.peopleCount = isNull(peopleCount) ? null : peopleCount;
    this.createdAt = isNull(createdAt) ? null : createdAt;
    this.deleted = isNull(deleted) ? null : deleted;
    this.visitType = isNull(visitType) ? null : visitType;
    this.collaborator = isNull(collaborator) ? null : collaborator;
    this.linkedPoll = isNull(linkedPoll) ? null : linkedPoll;
    this.customVisitHosts = isNull(customVisitHosts) ? null : customVisitHosts;
    this.hosts = isNull(hosts) ? null : hosts
    this.reason = isNull(reason) ? null : reason
    this.anyEmail = isNull(anyEmail) ? null : anyEmail
    this.status = isNull(status) ? null : status
    this.isFromSocket = isNull(isFromSocket) ? null : isFromSocket
  }

  _resetIsFromSocket() {
    this.isFromSocket = false;
  }

  copyWith({
    id = null,
    idBranch = null,
    name = null,
    date = null,
    startDate = null,
    endDate = null,
    peopleCount = null,
    createdAt = null,
    deleted = null,
    visitType = null,
    collaborator = null,
    linkedPoll = null,
    customVisitHosts = null,
    hosts = null,
    reason = null,
    anyEmail = null,
    isFromSocket = false,
    status = null

  } = {}) {
    return new ItemCollaborator({
      id: isNull(id) ? this.id : id,
      idBranch: isNull(idBranch) ? this.idBranch : idBranch,
      name: isNull(name) ? this.name : name,
      date: isNull(date) ? this.date : date,
      startDate: isNull(startDate) ? this.startDate : startDate,
      endDate: isNull(endDate) ? this.endDate : endDate,
      peopleCount: isNull(peopleCount) ? this.peopleCount : peopleCount,
      createdAt: isNull(createdAt) ? this.createdAt : createdAt,
      deleted: isNull(deleted) ? this.deleted : deleted,
      visitType: isNull(visitType) ? this.visitType : visitType,
      collaborator: isNull(collaborator) ? this.collaborator : collaborator,
      linkedPoll: isNull(linkedPoll) ? this.linkedPoll : linkedPoll,
      customVisitHosts: isNull(customVisitHosts) ? this.customVisitHosts : customVisitHosts,
      hosts: isNull(hosts) ? this.hosts : hosts,
      reason: isNull(reason) ? this.reason : reason,
      anyEmail: isNull(anyEmail) ? this.anyEmail : anyEmail,
      isFromSocket: isNull(isFromSocket) ? this.isFromSocket : isFromSocket,
      status: isNull(status) ? this.status : status
    })
  }
}